import {
  FETCH_SINGLE_ORDER,
  FETCH_SINGLE_ORDER_SUCCESS,
  FETCH_SINGLE_ORDER_FAILED
} from '../../types';

const initialState = {
  single_order: {},
  isLoading: false,
  errors: {},
  error: false
}

const fetchSingleOrderReducer = (state = initialState, action) => {

  switch (action.type) {
    case FETCH_SINGLE_ORDER:
      return {
        ...state,
        isLoading: true,
          single_order: action.payload
      }
      case FETCH_SINGLE_ORDER_SUCCESS:
        return {
          ...state,
          isLoading: false,
            single_order: action.payload
        }
        case FETCH_SINGLE_ORDER_FAILED:
          return {
            ...state,
            isLoading: false,
              errors: action.payload,
              error: true
          }
          default:
            return {
              ...state
            };
  }
}

export default fetchSingleOrderReducer;
